import api from "../services/api";

// Fetch deliveries function with credentials
export const fetchDeliveries = async (filterField, filterValue, page = 1, size = 50) => {
  try {
    const params = { page, size };
    if (filterField && filterValue) {
      params.filter_field = filterField;
      params.filter_value = filterValue;
    }

    // Make the API request with credentials
    const response = await api.get("/delivery-management/deliveries/", {
      params,
    });
    if (response.status === 200) {
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching deliveries:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to fetch deliveries";
    return { error: errorMessage };
  }
};

//function to update delivery status
export const updateDeliveryStatus = async (deliveryId, newStatus) => {
  try {
    const response = await api.put(
      `/delivery-management/deliveries/${deliveryId}/update`,
      {},
      {
        params: { delivery_data: newStatus },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating delivery status:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to update delivery status";
    return { error: errorMessage };
  }
};

//get driver distance travelled
export const fetchDriverTotalDistance = async (driverId) => {
  try {
    const response = await api.get(
      `/delivery-management/deliveries/admin/drivers/${driverId}/total-distance`
    );

    if (response.status === 200) {
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error(
      "Error fetching driver total distance:",
      error.message || error
    );

    const errorMessage =
      error.response?.data?.detail ||
      error.message ||
      "Failed to fetch driver total distance";

    return { error: errorMessage };
  }
};